import React from 'react';
import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './LoadingModal.css'; // For custom styles and animations

interface LoadingModalProps {
    open: boolean;
    text?: string; // Customizable text
}

const LoadingModal: React.FC<LoadingModalProps> = ({ open, text = "Bitte warten, Berechnungen laufen..." }) => {
    return (
        <Modal
            open={open}
            footer={null}
            closable={false}
            centered
            maskClosable={false}
            styles={{
                body: {
                    textAlign: 'center',
                    padding: '50px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '20px',
                }
            }}
        >
            <div className="loading-animation">
                <div className="dot dot1"></div>
                <div className="dot dot2"></div>
                <div className="dot dot3"></div>
            </div>
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{text}</div>
        </Modal>
    );
};

export default LoadingModal;
